import {
  BufferGeometry,
  BufferAttribute,
  MeshBasicMaterial,
  DoubleSide,
} from "three";
import { Point } from "./Data";

type MultiLocationProps = {
  point?: Point;
  zDimaintion: number;
  position?: [number, number][];
  color: string;
};

const MultiLocation = ({
  point,
  position,
  zDimaintion,
  color,
}: MultiLocationProps) => {
  const geometry = new BufferGeometry();

  // const vertices = new Float32Array(
  //   position ? position.map((loc) => [...loc, zDimaintion]).flat() :
  //   point ? point.location.map((loc) => [...loc, zDimaintion]).flat() : []
  // );
  let vertices: any;
  if (position) {
    // Duplicate the first vertex at the end to close the polygon
    vertices = position.map((loc) => [...loc, zDimaintion]).flat();
    vertices.push(...position[0], zDimaintion);
  } else if (point) {
    // Duplicate the first vertex at the end to close the polygon
    vertices = point.location.map((loc: any) => [...loc, zDimaintion]).flat();
    vertices.push(...(point.location[0] as any), zDimaintion);
  } else {
    vertices = [];
  }
  // Reorder the vertices to form a continuous loop
  const reorderedVertices = [];
  for (let i = 0; i < vertices.length; i += 9) {
    reorderedVertices.push(
      vertices[i],
      vertices[i + 1],
      vertices[i + 2],
      vertices[i + 3],
      vertices[i + 4],
      vertices[i + 5],
      vertices[i + 6],
      vertices[i + 7],
      vertices[i + 8],
    );
    reorderedVertices.push(
      vertices[i],
      vertices[i + 1],
      vertices[i + 2],
      vertices[i + 6],
      vertices[i + 7],
      vertices[i + 8],
      vertices[i + 9],
      vertices[i + 10],
      vertices[i + 11],
    );
  }

  geometry.setAttribute(
    "position",
    new BufferAttribute(new Float32Array(reorderedVertices), 3),
  );

  const material = new MeshBasicMaterial({
    color:
      color === "color1"
        ? "hsl(146.96,66.39%,36.67%)"
        : color === "color1Opacity"
          ? "hsl(146.96,66.39%,56.67%)"
          : color === "color2"
            ? "hsl(29.69,100%,62.35%)"
            : color === "color2Opacity"
              ? "hsl(29.69,100%,72.35%)"
              : color === "color3"
                ? "hsl(359.2,78.12%,62.35%)"
                : color === "color3Opacity"
                  ? "hsl(359.2,78.12%,72.35%)"
                  : color === "color4"
                    ? "hsl(0,0%,0%)"
                    : color === "color4Opacity"
                      ? "hsl(0,0%,30%)"
                      : "hsl(0,0%,100%)",
    side: DoubleSide,
  });

  // console.log("position", position);
  // console.log("vertices", vertices);
  return (
    <>
      <mesh geometry={geometry} material={material} />
    </>
  );
};

export default MultiLocation;
